import { useQuery } from '@tanstack/react-query';

import { apiService } from '../services/api';
import { mergeActiveCollectorAgencies } from '../utils/activeCollectorAgencies';

const STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Agências com dados no BD vindos de coleta ativa (BOT/API/scraping).
 * Lê apenas `/sources/summary` (regulatory → PostgreSQL), sem acionar BOTs.
 */
export function useActiveCollectorAgencies(options?: { enabled?: boolean }) {
  const enabled = options?.enabled !== false;

  const query = useQuery({
    queryKey: ['active-collector-agencies'],
    queryFn: async () => {
      const [federal, municipal] = await Promise.all([
        apiService.getSourcesSummaryByScope('federal'),
        apiService.getSourcesSummaryByScope('municipal'),
      ]);
      const agencies = mergeActiveCollectorAgencies(federal, municipal);
      return { agencies, count: agencies.length };
    },
    enabled,
    staleTime: STALE_TIME_MS,
    cacheTime: STALE_TIME_MS * 2,
  });

  return {
    agencies: query.data?.agencies ?? [],
    count: query.data?.count ?? 0,
    isLoading: query.isLoading,
  };
}
